import getApi from '../../api'
import { ToneAudiogram } from '../../model/Audiometry'

export const updateToneAudiogram = (id: number, payload: Partial<ToneAudiogram>) =>
  getApi().put<ToneAudiogram>(`/audiometry/tone_audiograms/${id}`, payload)
